import React from "react";
import classNames from "classnames";

interface ButtonProps {
  handleClick: () => void;
  prefixIcon?: any;
  suffixIcon?: any;
  buttonText: string;
  theme?: string;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
}

function Button({
  handleClick,
  buttonText,
  className,
  prefixIcon,
  disabled,
  suffixIcon,
}: ButtonProps) {
  const buttonClasses = classNames(className, {});
  return (
    <button disabled={disabled} className={buttonClasses} onClick={handleClick}>
      {prefixIcon && <span className="mr-1">{prefixIcon}</span>}
      {buttonText}
      {suffixIcon && <span className="ml-2 ">{suffixIcon}</span>}

    </button>
  );
}

export default Button;
